import { fetchConToken, handleError } from '../../helpers/fetch'
import theme from '../../material-ui/theme'
import Swal from 'sweetalert2'
import { loadStatusPanelText } from '../../helpers/panels/statusPanels'
import {
  panelsDynamicProfilesLoad,
  panelsDynamicProfilesActive,
  panelsDynamicProfilesRemoveActive,
} from './panelsDynamicProfilesReducer'

const isDynamicLightingEnabled = (state) => {
  const { contracts: { activeContract: active } } = state
  return active && active.cm_adaptative === 1
}

const getProfileFromResponse = response => {
  return Array.isArray(response) ? response[0] : response
}

const getProfileBody = profile => {
  return {
    name: profile?.name,
    date: profile?.date,
    status_flag: profile?.status_flag,
    sunset_switch_on_threshold: profile?.sunset_switch_on_threshold,
    sunrise_switch_on_threshold: profile?.sunrise_switch_on_threshold,
    description: profile?.description
  }
}

export const startPanelsDynamicProfilesLoad = () => {
  return (dispatch, getState) => {

    const state = getState()

    if (!isDynamicLightingEnabled(state)) return

    const { contracts: { activeContract: active } } = state

    if (active && active.id) {

      const fields = [
        'id',
        'name',
        'contract_id',
        'contract_name',
        'date',
        'status_flag',
        'sunset_switch_on_threshold',
        'sunrise_switch_on_threshold',
        'description'
      ]

      fetchConToken(`contract/${active.id}/panels/adaptative-profiles?fields=${fields.toString()}`)
        .then(result => {
          if (!result.ok) {
            throw result.status
          }
          return result
        })
        .then(result => result.json())
        .then(profiles => {
          dispatch(panelsDynamicProfilesLoad(profiles))
        })
        .catch(err => {
          handleError(err, dispatch)
        })

    }

  }
}

export const startPanelsDynamicProfilesActive = id => {
  return (dispatch, getState) => {

    const state = getState()

    if (!isDynamicLightingEnabled(state)) return

    const {
      contracts: { activeContract: active },
      panelsDynamicProfiles: { profiles }
    } = state

    if (active && active.id && id) {

      const fields = [
        'id',
        'name',
        'contract_id',
        'contract_name',
        'date',
        'status_flag',
        'sunset_switch_on_threshold',
        'sunrise_switch_on_threshold',
        'description'
      ]

      fetchConToken(`contract/${active.id}/panels/adaptative-profiles/${id}?fields=${fields.toString()}`)
        .then(result => {
          if (!result.ok) {
            throw result.status
          }
          return result
        })
        .then(result => result.json())
        .then(response => {

          const profile = getProfileFromResponse(response)

          dispatch(panelsDynamicProfilesLoad(
            profiles.map(e => (e.id === id) ? profile : e)
          ))

          dispatch(panelsDynamicProfilesActive(profile))

        })
        .catch(err => {
          handleError(err, dispatch)
        })

    }

  }
}

export const startPanelsDynamicProfilesCreate = (data) => {

  return (dispatch, getState) => {

    const state = getState()

    if (!isDynamicLightingEnabled(state)) return

    const {
      contracts: { activeContract: active },
    } = state


    if (active && active.id && typeof data === 'object') {
      Swal.fire({
        title: 'Cargando...',
        text: 'Por favor espera',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading()
        },
      })

      fetchConToken(`contract/${active.id}/panels/adaptative-profiles`, data, 'POST')
        .then(result => {
          if (!result.ok && result.status !== 405) {
            throw result.status;
          }
          return result;
        })
        .then(result => [result.json(), result.status])
        .then(([result, status]) => {
          if (status === 405) {
            Swal.fire({
              titleText: 'Error',
              text: loadStatusPanelText(1, data),
              icon: 'warning',
              confirmButtonColor: theme.palette.primary.main,
            });
          } else {
            dispatch(startPanelsDynamicProfilesLoad())
            dispatch(panelsDynamicProfilesRemoveActive())

            Swal.fire({
              titleText: 'Guardado',
              text: `¡${data?.name || ''} actualizado!`,
              icon: 'success',
              confirmButtonColor: theme.palette.primary.main,
            })
          }
        })
        .catch(err => {
          handleError(err, dispatch)
        })
    }
  }
}

export const startPanelsDynamicProfilesUpdate = (data) => {
  return (dispatch, getState) => {

    const state = getState()

    if (!isDynamicLightingEnabled(state)) return

    const {
      contracts: { activeContract: active },
      panelsDynamicProfiles: { active: profile }
    } = state

    const id = profile?.id
    if (active && active.id && id && typeof data === 'object' && data.id) {
      Swal.fire({
        title: 'Cargando...',
        text: 'Por favor espera',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading()
        },
      })
      fetchConToken(`contract/${active.id}/panels/adaptative-profiles/${id}`, data, 'PATCH')
        .then(result => {
          if (!result.ok && result.status !== 405) {
            throw result.status;
          }
          return result;
        })
        .then(result => [result.json(), result.status])
        .then(([result, status]) => {
          if (status === 405) {
            Swal.fire({
              titleText: 'Error',
              text: loadStatusPanelText(1, data),
              icon: 'warning',
              confirmButtonColor: theme.palette.primary.main,
            });
          } else {
            dispatch(startPanelsDynamicProfilesLoad())
            Swal.fire({
              titleText: 'Guardado',
              text: `¡${data?.name || ''} actualizado!`,
              icon: 'success',
              confirmButtonColor: theme.palette.primary.main,
            })
          }
        })
        .catch(err => {
          handleError(err, dispatch)
        })
    }
  }
}

export const startPanelsDynamicProfilesDelete = () => {
  return (dispatch, getState) => {

    const state = getState()

    if (!isDynamicLightingEnabled(state)) return

    const {
      contracts: { activeContract: active },
      panelsDynamicProfiles: { active: { name, id }, profiles }
    } = state

    if (!name || !id || !active) {
      return
    }

    Swal.fire({
      title: 'Cargando...',
      text: 'Por favor espera',
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading()
      },
    })

    fetchConToken(`contract/${active.id}/panels/adaptative-profiles/${id}`, null, 'DELETE')
      .then(result => {
        if (!result.ok) {
          throw result.status
        }
        return result
      })
      .then(result => result.json())
      .then(() => {

        dispatch(panelsDynamicProfilesLoad(profiles.filter(e => e.id !== id)))
        dispatch(panelsDynamicProfilesRemoveActive())

        Swal.fire({
          titleText: 'Guardado',
          text: `¡${name} actualizado!`,
          icon: 'success',
          confirmButtonColor: theme.palette.primary.main,
        })

      })
      .catch(err => {
        handleError(err, dispatch)
      })

  }
}